import React, { useState, useEffect } from "react";
import { Phone, Send } from "lucide-react";
import { telHref, telegramLink } from "../lib/config";
import { trackCall, trackEvent } from "../lib/analytics";
import { T } from "../lib/i18n";

export default function StickyAndFloat({ lang }) {
  const [showFloat, setShowFloat] = useState(false);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowFloat(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Sticky mobile bottom bar — ONLY Call + Telegram */}
      <div
        className="md:hidden fixed bottom-0 inset-x-0 z-40 safe-bottom"
        data-testid="sticky-mobile-cta"
      >
        <div className="mx-2 mb-2 glass rounded-2xl p-2 flex items-stretch gap-2 shadow-[0_-10px_30px_rgba(0,0,0,0.5)]">
          <a
            href={telHref}
            onClick={() => trackCall("sticky_mobile")}
            data-testid="sticky-call-button"
            className="flex-[1.4] cta-pulse inline-flex items-center justify-center gap-2 btn-call rounded-xl px-3 py-3.5 text-base font-bold"
          >
            <Phone size={18} strokeWidth={2.8} /> {T.cta.callShort[lang]}
          </a>
          <a
            href={telegramLink}
            target="_blank" rel="noreferrer"
            onClick={() => trackEvent("ClickTelegram", { source: "sticky", language: lang })}
            data-testid="sticky-telegram-button"
            className="flex-1 inline-flex items-center justify-center gap-2 rounded-xl px-3 py-3.5 text-base font-bold transition hover:brightness-110"
            style={{ background: "#229ED9", color: "white" }}
            aria-label="Telegram"
          >
            <Send size={18} strokeWidth={2.6} /> Telegram
          </a>
        </div>
      </div>

      {/* Floating desktop call button */}
      <div
        className={`hidden md:block fixed right-5 bottom-5 z-40 transition-all duration-500 ${showFloat ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        data-testid="floating-call-container"
      >
        <div className="flex flex-col items-end gap-3">
          <a
            href={telegramLink}
            target="_blank" rel="noreferrer"
            onClick={() => trackEvent("ClickTelegram", { source: "floating_desktop", language: lang })}
            data-testid="floating-telegram-button"
            className="inline-flex items-center gap-2 rounded-full pl-4 pr-5 py-3 font-bold shadow-lg transition hover:brightness-110"
            style={{ background: "#229ED9", color: "white" }}
          >
            <Send size={18} strokeWidth={2.6} /> Telegram
          </a>
          <a
            href={telHref}
            onClick={() => trackCall("floating_desktop")}
            data-testid="floating-call-button"
            className="cta-pulse inline-flex items-center gap-3 btn-call rounded-full pl-4 pr-5 py-3.5 shadow-flame"
          >
            <Phone size={20} strokeWidth={2.6} />
            <span className="font-bold">
              {hover ? (lang === "uz" ? "1 daqiqada model tanlaymiz" : "Подберём модель за 1 минуту") : T.cta.callShort[lang]}
            </span>
          </a>
        </div>
      </div>
    </>
  );
}
